// Sentry error tracking initialization for the frontend.
// DSN is read from VITE_SENTRY_DSN env var — if missing, Sentry is disabled (no errors thrown).

import * as Sentry from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN;

export function initSentry(): void {
  if (!dsn) {
    console.warn("[Sentry] VITE_SENTRY_DSN not set — error tracking disabled");
    return;
  }

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE, // "production" | "development" | "preview"
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: import.meta.env.MODE === "production" ? 0.2 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    // Do not send PII (emails, IPs) — Senegal Loi 2008-12
    sendDefaultPii: false,
  });
}

export { Sentry };
